import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Flex,
  Heading,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  useAuthenticator,
} from "@aws-amplify/ui-react";

import { useUserQuery } from "../common/useUserQuery";
import { useMinorDependentsQuery } from "./api/useMinorDependentsQuery";
import { useUserMutation } from "../common/useUserMutation";

export default function MinorDependentsPage() {
  const navigate = useNavigate();
  const { user } = useAuthenticator((context) => [context.user]);
  const { data: userQuery } = useUserQuery();
  const { mutate: userMutate } = useUserMutation();
  const { data: minorDependentsQuery, isFetching } = useMinorDependentsQuery(
    userQuery?.patientUserId
  );

  // SETS GLOBAL PROFILE TO SELECTED USER
  const handleSwitchToProfileClick = (
    patientUserId,
    patientUserGivenName = "",
    patientUserNickname = ""
  ) => {
    const advocateSessionObject = {
      patientUserId: patientUserId,
      isAdvocating: true,
      givenName: patientUserGivenName,
      nickname: patientUserNickname,
    };
    sessionStorage.setItem(
      "advocateSession",
      JSON.stringify(advocateSessionObject)
    );
    userMutate(advocateSessionObject);
    navigate("/user/quick-actions/insights");
  };

  // RESETS GLOBAL PROFILE TO LOGGED IN USER
  const handleStopSessionClick = () => {
    sessionStorage.removeItem("advocateSession");
    userMutate({ patientUserId: user?.userId, isAdvocating: false });
  };

  return (
    <Flex
      direction="column"
      padding="32px 32px 32px 32px"
      backgroundColor="rgba(250,250,250,1)"
    >
      <Flex direction="row" alignItems="center">
        <Heading level="1" children="Minor Dependents"></Heading>
        <Button
          size="small"
          variation="primary"
          onClick={() => navigate("/user/hr/minor-dependents/add")}
        >
          Add
        </Button>
      </Flex>
      <Flex direction="column">
        {isFetching ? (
          <span>Loading...</span>
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell as="th">Action</TableCell>
                <TableCell as="th">Given Name</TableCell>
                <TableCell as="th">Relationship</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {minorDependentsQuery?.map((minor) => (
                <TableRow key={`mdp_md_${minor?.minorUserId}`}>
                  <TableCell>
                    {userQuery?.patientUserId === minor?.minorUserId ? (
                      <Button
                        size="small"
                        variation="destructive"
                        onClick={handleStopSessionClick.bind(
                          this,
                          minor?.minorUserId
                        )}
                      >
                        STOP SESSION
                      </Button>
                    ) : (
                      <Button
                        size="small"
                        variation="primary"
                        onClick={handleSwitchToProfileClick.bind(
                          this,
                          minor?.minorUserId,
                          minor?.givenName,
                          minor?.nickname
                        )}
                      >
                        SWITCH
                      </Button>
                    )}
                  </TableCell>
                  <TableCell>{minor?.givenName}</TableCell>
                  <TableCell>{minor?.minorRelationship}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Flex>
    </Flex>
  );
}
